if (!Array.prototype.find) {
  Array.prototype.find = function (predicate) {
    'use strict'
    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined')
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function')
    }
    var list = Object(this)
    var length = list.length >>> 0
    var thisArg = arguments[1]
    var value

    for (var i = 0; i < length; i++) {
      value = list[i]
      if (predicate.call(thisArg, value, i, list)) {
        return value
      }
    }
    return undefined
  }
}

if (!Number.prototype.formatMoney) {
  Number.prototype.formatMoney = function (aPrefix, aThousand, aDecimal, aSuffix) {
    return aPrefix + this.toString().match(/.{1,3}/g).reduce((aTotal, aValue, aIndex, aArray) => {
      return aTotal + aValue
    }, '') + aSuffix
  }
}



// WEBPACK FOOTER //
// ./src/polyfills.js